import styled from 'styled-components/macro';

import {
  CardContainer,
  CardIcon,
  CardItem,
  CardLabel,
  CardLabelContainer,
  CardTitle,
  CardValue,
} from 'common/components/Card/card.styled';

export const PageDetailsSubTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  color: ${({ theme }) => theme.colors.black_80};
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};
`;

export const PageDetailsTitle = styled(CardTitle)`
  margin-bottom: ${({ theme }) => theme.spacing.one_2};
`;

export const Container = styled(CardContainer)`
  :first-of-type {
    margin-top: 0;
  }
`;

export const Item = styled(CardItem)<{ padding?: string }>`
  ${CardLabel} {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-family: ${({ theme }) => theme.fontFamily.semiBold};
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  }

  ${CardValue} {
    font-size: ${({ theme }) => theme.fontSize.xs};
  }
  padding: ${({ padding }) => (padding ? padding : '')};
`;

export const LabelContainer = styled(CardLabelContainer)`
  ${CardLabel} {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-family: ${({ theme }) => theme.fontFamily.regular};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
    color: ${({ theme }) => theme.colors.black_100};
    line-height: ${({ theme }) => theme.lineHeight.one_3};
    margin-bottom: ${({ theme }) => theme.spacing.one};
  }

  ${CardIcon} {
    line-height: ${({ theme }) => theme.lineHeight.one_3};
  }
`;
